import { SortDirType } from "../../../common/SortDirType";
import { SortParams } from "../../../common/SortParams";

export const sortByFields = [
  { label: "Activity", value: "ACTIVITY" },
  { label: "Activity Date", value: "ACTIVITY_DATE" },
  { label: "Container Number", value: "CONTAINER_NUMBER" },
  { label: "Trailer Number", value: "TRAILER_NUMBER" },
  { label: "Chassis Number", value: "CHASSIS_NUMBER" },
  { label: "Chassis License Plate Number", value: "CHASSIS_LICENSE_PLATE_NUMBER" },
  { label: "Asset Size", value: "ASSET_SIZE" },
  { label: "Driver First Name", value: "DRIVER_FIRST_NAME" },
  { label: "Driver Last Name", value: "DRIVER_LAST_NAME" },
  { label: "Driver License Number", value: "DRIVER_LICENSE_NUMBER" },
  { label: "Seal Number", value: "SEAL_NUMBER" },
  { label: "Asset Type", value: "ASSET_TYPE" },
  { label: "Order Number", value: "ORDER_NUMBER" },
  { label: "Location Name", value: "LOCATION_NAME" },
  { label: "Buyer Name", value: "BUYER_NAME" },
  { label: "Supplier Name", value: "SUPPLIER_NAME" },
  { label: "Current Inventory", value: "CURRENT_INVENTORY" },
] as const satisfies Array<{label: string, value: string}>;

export type AdminInventoryActivitySortByType = typeof sortByFields[number]['value'];

export interface AdminInventoryActivitySortParams extends SortParams {
  sortBy?: AdminInventoryActivitySortByType;
  sortDir?: SortDirType
}